import { AntibioticsTestStatus, FgStatusEnum, GlobalStatus, PlantsEnum, ShiftsEnum, SubPlantCodesEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("grade_inventory")
export class GradeInventory {

    @PrimaryGeneratedColumn("increment", { name: 'grade_inv_id' })
    gradeInvId: number;

    @Column('int', {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;  
    @Column('int', {
        nullable: true,
        name: "sub_plant_id"
    })
    subPlantId: number;  

    @Column("varchar", {
        nullable: false,
        name: "lot_number",
        length: 50
    })
    lotNumber: string;

    @Column("int", {
        nullable: false,
        name: "grade"
    })
    grade: number;

    @Column("int", {
        nullable: false,
        name: "boxes"
    })
    boxes: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "quantity"
    })
    quantity: number; 

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "issued_quantity"
    })
    issuedQuantity: number;

    @Column("varchar", {
        nullable: true,
        name: "planned_so_number",
        length: 50
    })
    plannedSoNumber: string;
    @Column("int", {
        nullable: false,
        default: 0,
        name: "issued_boxes"
    })
    issuedBoxes: number;

    //new columns added for reports BE calculations purpose (from honCount to amount)
    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "hon_count"
    })
    honCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "hon_quantity"
    })
    honQuantity: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "rm_rate"
    })
    rmRate: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "amount"
    })
    amount: number; 

    @Column('varchar',{
        name:'grade_range',
        length:30,
        nullable:true
    })
    gradeRange: string

    @Column( {
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "grn_hon_count"
    })
    grnHonCount: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "grn_hon_quantity"
    })
    grnHonQuantity: number; 

    @Column({
        type: "decimal", precision: 10, scale: 2,
        nullable: false,
        name: "grn_rm_rate"
    })
    grnRmRate: number; 

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "flag"
    })
    flag: boolean;

    @Column("int", {
        nullable: true,
        name: "supervisor"
    })
    supervisor: number;
    

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column('boolean',{
        name:'material_from',
        default:false
    })
    materialFrom : boolean

    @Column('varchar',{
        name:'main_lot',
        length:30
    })
    mainLot : string;

    @Column('int',{
        name:'year'
    })
    year:number
    
    @Column('varchar',{
        name:'test_result',
        length:30,
        nullable:true
    })
    testResult: string

    @Column({
        type:'enum',
        enum: AntibioticsTestStatus, 
        name: 'antibiotics_test_status',
        nullable:false,
        default:AntibioticsTestStatus.PENDING,
    })
    antibioticsTestStatus: AntibioticsTestStatus; 

    @Column({
        type: "decimal", precision: 5, scale: 2,
        nullable: true,
        default: 0,
        name: "price_count"
    })
    priceCount: number;

   
}